import { Trans } from 'react-i18next';
import PersonOffIcon from '@mui/icons-material/PersonOff';
import { ROUTES } from '@routes/routes';
import { NotificationPresenter } from '@notifications/interfaces';
import { MemberWithdrewFromCompetitionNotificationData } from './interfaces';

const isMemberWithdrewFromCompetitionPayload = (
  payload: unknown
): payload is MemberWithdrewFromCompetitionNotificationData => {
  if (typeof payload !== 'object' || payload === null) {
    return false;
  }

  return 'memberName' in payload && typeof payload.memberName === 'string';
};

export const memberWithdrewFromCompetitionPresenter: NotificationPresenter<MemberWithdrewFromCompetitionNotificationData> =
  {
    type: 'member-withdrew-from-competition',
    icon: PersonOffIcon,
    isPayload: isMemberWithdrewFromCompetitionPayload,
    label: (payload, t) =>
      t('notifications:types.member-withdrew-from-competition', {
        memberName: payload.memberName,
        competitionName: payload.competitionName,
      }),
    message: (payload) => (
      <Trans
        i18nKey="notifications:menu.member-withdrew-from-competition"
        values={{
          memberName: payload.memberName,
          competitionName: payload.competitionName,
        }}
        components={{
          bold: <strong />,
        }}
      />
    ),
    path: (payload) => {
      if (!payload.competitionSlug) {
        return null;
      }

      return `${ROUTES.manage.competitions.details(payload.competitionSlug)}?tab=withdrawals`;
    },
  };
